import { useEffect, useState, useCallback, useRef } from "react";
import { supabase, getPendingTransfersFor } from "@/lib/supabase";

const POLL_MS = 30000;

export function usePendingTransfers(asesorId) {
  const [transfers, setTransfers] = useState([]);
  const [outgoing, setOutgoing] = useState([]);
  const [loading, setLoading] = useState(false);
  const channelsRef = useRef([]);

  const refresh = useCallback(async () => {
    if (!asesorId) {
      setTransfers([]);
      setOutgoing([]);
      return;
    }
    setLoading(true);
    const [incoming, outRes] = await Promise.all([
      getPendingTransfersFor(asesorId),
      supabase
        .from("lead_transfers")
        .select(`id, lead_id, motivo, created_at, to_asesor:to_asesor_id(nombre)`)
        .eq("from_asesor_id", asesorId)
        .eq("status", "pending"),
    ]);
    setTransfers(incoming);
    setOutgoing(outRes?.data || []);
    setLoading(false);
  }, [asesorId]);

  useEffect(() => {
    if (!asesorId) return;
    refresh();

    const interval = setInterval(refresh, POLL_MS);

    const channelTo = supabase
      .channel(`transfers-to-${asesorId}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "lead_transfers",
          filter: `to_asesor_id=eq.${asesorId}`,
        },
        () => refresh(),
      )
      .subscribe();
    const channelFrom = supabase
      .channel(`transfers-from-${asesorId}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "lead_transfers",
          filter: `from_asesor_id=eq.${asesorId}`,
        },
        () => refresh(),
      )
      .subscribe();
    channelsRef.current = [channelTo, channelFrom];

    return () => {
      clearInterval(interval);
      channelsRef.current.forEach((ch) => supabase.removeChannel(ch));
    };
  }, [asesorId, refresh]);

  return { transfers, outgoing, loading, refresh };
}
